var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"column text-h5 items-center q-mt-md text-center"},[_vm._v("Welcome to the Image Manager "),_c('br'),_vm._v(" Please use the Left bar for navigation")])
}]

export { render, staticRenderFns }